import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  loading?: boolean;
  readMoreText: string;
  featured?: boolean;
} & {
  id?: string;
  title?: string;
  content?: string;
  className?: string;
  global?: boolean;
  author?: string;
} & IWithCountryProps;

export const NewsItemFooter: React.SFC<Props> = props => (
  <StyledLink
    to={`/${props.global ? 'global' : props.country}/article/${props.id}`}
    className={props.className}
    featured={props.featured}
  >
    <Left>
      <Title>{props.title}</Title>
      <Subtitle>
        {props.content}
        {props.author && <span>&nbsp; | &nbsp; Author: {props.author}</span>}
      </Subtitle>
    </Left>
    <Right>
      {!props.loading && <ReadMore>{props.readMoreText} ></ReadMore>}
    </Right>
  </StyledLink>
);

const ReadMore = styled.div`
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
`;

const Title = styled.div`
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 6px;
`;

const Subtitle = styled.div`
  font-size: 12px;
`;

const Left = styled.div`
  flex: 1;
  @media (max-width: 750px) {
    width: 100%;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 750px) {
    flex: 1;
    margin-top: 15px;
  }
`;

const StyledLink = styled(Link)<{ featured?: boolean }>`
  display: flex;
  justify-content: space-between;
  height: 100%;
  flex: 1;
  text-decoration: none;
  padding: 24px 24px 26px 14px;
  align-items: center;
  ${p => !p.featured && `flex-direction: column;`}
  ${Right} {
    ${p =>
      !p.featured &&
      `justify-content: flex-end; width: 100%; margin-top: 20px;`}
  }
  @media (max-width: 750px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;

export default withCountry(NewsItemFooter);



// WEBPACK FOOTER //
// ./src/components/NewsItem/NewsItemFooter.tsx